import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  contactInfo = [
  { icon: 'bi-geo-alt', text: 'Suite 502, Creative Hub, Los Angeles, CA' },
  { icon: 'bi-envelope-open', text: 'support@yoursite.com' },
  { icon: 'bi-telephone', text: '+1 (234) 567-8900' }
  ];

  socialLinks = [
    { icon: 'fab fa-x-twitter', link: '#' },
    { icon: 'fab fa-facebook-f', link: '#' },
    { icon: 'fab fa-linkedin-in', link: '#' },
    { icon: 'fab fa-instagram', link: '#' }
  ];

  quickLinks = [
    { name: 'Home', link: '/' },
    { name: 'About', link: '/about-us' },
    { name: 'Services', link: '/services' },
    { name: 'Team', link: '/our-team' },
    { name: 'Blog', link: '/blog-grid' },
    { name: 'Contact', link: '/contact' }
  ];

  resources = [
    { name: 'FAQs', link: '#' },
    { name: 'Privacy Policy', link: '#' },
    { name: 'Terms & Conditions', link: '#' },
    { name: 'Careers', link: '#' },
    { name: 'Support', link: '#' },
    { name: 'Sitemap', link: '#' }
  ];
  currentYear = new Date().getFullYear();
}
